import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BlurRevealText from "./BlurRevealText";

const stroke = "#003FB1";

// Order matches platformCapabilities.capabilities in the locale files.
const capabilityIconTypes = [
  "provisioning",
  "customers",
  "billing",
  "analytics",
  "pricing",
  "partners",
  "api",
  "fraud",
  "notifications",
];

export function CapabilityIcon({ type }) {
  const common = {
    width: 28,
    height: 28,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": true,
  };

  if (type === "provisioning") {
    return (
      <svg {...common}>
        <rect
          x="6"
          y="4"
          width="20"
          height="24"
          rx="4"
          stroke={stroke}
          strokeWidth="1.75"
        />
        <rect
          x="11"
          y="12"
          width="10"
          height="9"
          rx="2"
          stroke={stroke}
          strokeWidth="1.6"
        />
        <path
          d="M11 16.5h10M16 12v9"
          stroke={stroke}
          strokeWidth="1.4"
          strokeLinecap="round"
        />
      </svg>
    );
  }

  if (type === "customers") {
    return (
      <svg {...common}>
        <circle cx="12" cy="11" r="4.5" stroke={stroke} strokeWidth="1.75" />
        <path
          d="M3.5 26c0-4.7 3.8-8.5 8.5-8.5s8.5 3.8 8.5 8.5"
          stroke={stroke}
          strokeWidth="1.75"
          strokeLinecap="round"
        />
        <path
          d="M21.5 7.4a4.5 4.5 0 0 1 0 8.2M23 18.2c3.2 1.1 5.5 4.2 5.5 7.8"
          stroke={stroke}
          strokeWidth="1.6"
          strokeLinecap="round"
        />
      </svg>
    );
  }

  if (type === "billing") {
    return (
      <svg {...common}>
        <rect
          x="3.5"
          y="7"
          width="25"
          height="18"
          rx="3.5"
          stroke={stroke}
          strokeWidth="1.75"
        />
        <path d="M3.5 13h25" stroke={stroke} strokeWidth="1.75" />
        <path
          d="M8 19.5h5M18 19.5h6"
          stroke={stroke}
          strokeWidth="1.6"
          strokeLinecap="round"
        />
      </svg>
    );
  }

  if (type === "analytics") {
    return (
      <svg {...common}>
        <path
          d="M4 26h24"
          stroke={stroke}
          strokeWidth="1.75"
          strokeLinecap="round"
        />
        <path
          d="M8.5 26v-6M15 26v-11M21.5 26v-8"
          stroke={stroke}
          strokeWidth="1.75"
          strokeLinecap="round"
        />
        <path
          d="m6 13 6-5 5 4 9-8"
          stroke={stroke}
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  if (type === "pricing") {
    return (
      <svg {...common}>
        <path
          d="M16.6 3.5H26a2.5 2.5 0 0 1 2.5 2.5v9.4a2.5 2.5 0 0 1-.73 1.77l-10 10a2.5 2.5 0 0 1-3.54 0l-9.4-9.4a2.5 2.5 0 0 1 0-3.54l10-10a2.5 2.5 0 0 1 1.77-.73z"
          stroke={stroke}
          strokeWidth="1.75"
          strokeLinejoin="round"
        />
        <circle cx="22" cy="10" r="2.2" stroke={stroke} strokeWidth="1.6" />
      </svg>
    );
  }

  if (type === "partners") {
    return (
      <svg {...common}>
        <circle cx="16" cy="6.5" r="3.5" stroke={stroke} strokeWidth="1.75" />
        <circle cx="6.5" cy="24" r="3.5" stroke={stroke} strokeWidth="1.75" />
        <circle cx="25.5" cy="24" r="3.5" stroke={stroke} strokeWidth="1.75" />
        <path
          d="M13.4 8.6 8.6 20.4M18.6 8.6l4.8 11.8M10 24h12"
          stroke={stroke}
          strokeWidth="1.6"
          strokeLinecap="round"
        />
      </svg>
    );
  }

  if (type === "api") {
    return (
      <svg {...common}>
        <path
          d="M11 9.5 4.5 16 11 22.5M21 9.5 27.5 16 21 22.5M18.5 6.5l-5 19"
          stroke={stroke}
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  if (type === "fraud") {
    return (
      <svg {...common}>
        <path
          d="M16 3.5 27 8v8c0 7-4.5 11-11 13C9 27 4.5 23 4.5 16V8z"
          stroke={stroke}
          strokeWidth="1.75"
          strokeLinejoin="round"
        />
        <path
          d="M16 11v6"
          stroke={stroke}
          strokeWidth="1.75"
          strokeLinecap="round"
        />
        <circle cx="16" cy="21" r="1.15" fill={stroke} />
      </svg>
    );
  }

  if (type === "whitelabel") {
    return (
      <svg {...common}>
        <rect
          x="4"
          y="6"
          width="24"
          height="19"
          rx="3.5"
          stroke={stroke}
          strokeWidth="1.75"
        />
        <path
          d="M4 11.5h24"
          stroke={stroke}
          strokeWidth="1.6"
        />
        <circle cx="7.5" cy="8.75" r="0.9" fill={stroke} />
        <circle cx="10.5" cy="8.75" r="0.9" fill={stroke} />
        <path
          d="M9 16h7M9 20h11"
          stroke={stroke}
          strokeWidth="1.6"
          strokeLinecap="round"
        />
      </svg>
    );
  }

  if (type === "coverage") {
    return (
      <svg {...common}>
        <circle cx="16" cy="16" r="11" stroke={stroke} strokeWidth="1.75" />
        <ellipse cx="16" cy="16" rx="4.5" ry="11" stroke={stroke} strokeWidth="1.5" />
        <path
          d="M5 16h22M7.2 10.5h17.6M7.2 21.5h17.6"
          stroke={stroke}
          strokeWidth="1.5"
        />
      </svg>
    );
  }

  // notifications
  return (
    <svg {...common}>
      <path
        d="M16 4a8 8 0 0 1 8 8v5.5l2 3.5H6l2-3.5V12a8 8 0 0 1 8-8z"
        stroke={stroke}
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
      <path
        d="M13 24.5a3 3 0 0 0 6 0"
        stroke={stroke}
        strokeWidth="1.75"
        strokeLinecap="round"
      />
    </svg>
  );
}

function CapabilitiesArrowIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <path
        d="M10.4688 4.375L16.0938 10L10.4688 15.625M15.3125 10H3.90625"
        stroke="currentColor"
        strokeWidth="1.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function PlatformCapabilities() {
  const { t } = useTranslation();
  const capabilities = t("platformCapabilities.capabilities", {
    returnObjects: true,
  });

  const titleSegments = [
    { text: t("platformCapabilities.titleBefore"), breakAfter: true },
    {
      text: t("platformCapabilities.titleHighlight"),
      className: "platform-capabilities-accent",
    },
    { text: t("platformCapabilities.titleAfter") },
  ];

  return (
    <section className="platform-capabilities-section py-50">
      <div className="container">
        <div className="platform-capabilities-head">
          <p className="banner-sub-heading p-2">
            {t("platformCapabilities.overline")}
          </p>
          <BlurRevealText
            as="h2"
            className="platform-capabilities-title"
            segments={titleSegments}
          />
          <p className="platform-capabilities-subtitle">
            {t("platformCapabilities.subtitle")}
          </p>
        </div>

        <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 g-3 g-xl-4">
          {capabilities.map((item, index) => (
            <div className="col" key={item.title}>
              <article className="platform-capability-card h-100">
                <span className="platform-capability-icon">
                  <CapabilityIcon type={capabilityIconTypes[index]} />
                </span>
                <div>
                  <h3 className="platform-capability-title">{item.title}</h3>
                  <p className="platform-capability-text">{item.description}</p>
                </div>
              </article>
            </div>
          ))}
        </div>

        <Link className="platform-capabilities-link" to="/technology">
          {t("platformCapabilities.cta")}
          <CapabilitiesArrowIcon />
        </Link>
      </div>
    </section>
  );
}

export default PlatformCapabilities;
